import React, { useEffect } from "react";
import { Control, FieldValues, useForm } from "react-hook-form";
import SelectField from "components/UI/SelectField";
import { SelectFieldOption } from "components/UI/SelectField/SelectField.type";
import { UNIT_TYPES } from "constant/dl_unit/unit_type.constant";

type UnitTypeSelectProps<T extends FieldValues = FieldValues> = {
  control?: Control<T>;
  defaultValue?: string;
  label?: string;
  name?: string;
  onSelect?: (value: string) => void;
};

const UNIT_TYPE_SELECT_OPTIONS: SelectFieldOption[] = Object.values(
  UNIT_TYPES,
).map((unitType) => ({ value: unitType, label: unitType }));

const UnitTypeSelect = <T extends FieldValues = FieldValues>({
  control,
  defaultValue = UNIT_TYPES.KD,
  label = "",
  name = "uType",
  onSelect,
}: UnitTypeSelectProps<T>) => {
  const { control: localControl, reset } = useForm({
    defaultValues: {
      [name]: defaultValue,
    },
  });

  useEffect(() => {
    if (!control) {
      reset({
        [name]: defaultValue,
      });
    }
  }, [control, defaultValue, name, reset]);

  return (
    <SelectField
      name={name}
      control={(control ?? localControl) as Control<any>}
      label={label}
      defaultValue={defaultValue}
      options={UNIT_TYPE_SELECT_OPTIONS}
      onSelect={onSelect}
    />
  );
};

export default UnitTypeSelect;
